import PropTypes from 'prop-types'
import ContextMenuComponent from '../../../context-menu'
import {
  contextMenuAlignOptions,
  contextMenuTitleWeightOptions
} from '../../../context-menu/constants'
import OrganizationalIcon from './organizational-icon'
import { useIntl } from 'react-intl'

import { Licenses, Templates } from '../../../../atoms/icons/menu'
import { useState } from 'react'

const OrganizationalMenu = ({
  onClickManageUsers,
  onClickReportTemplates,
  canSeeReportTemplates = false,
  canSeeUserManagement = false
}) => {
  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(false)

  const handleClickManageUsers = () => {
    setIsOpen(false)
    onClickManageUsers && onClickManageUsers()
  }

  const handleClickReportTemplates = () => {
    setIsOpen(false)
    onClickReportTemplates && onClickReportTemplates()
  }

  return (
    <ContextMenuComponent.Root setIsOpen={setIsOpen} isOpen={isOpen}>
      <ContextMenuComponent.Trigger>
        <OrganizationalIcon />
      </ContextMenuComponent.Trigger>
      <ContextMenuComponent.List
        align={contextMenuAlignOptions.START}
        width="240px"
      >
        {canSeeUserManagement && (
          <ContextMenuComponent.Item
            leadingIcon={<Licenses />}
            id="user_management"
            title={formatMessage({ id: 'user_management' })}
            titleWeight={contextMenuTitleWeightOptions['TEXT-600']}
            onClick={handleClickManageUsers}
          />
        )}

        {canSeeReportTemplates && (
          <ContextMenuComponent.Item
            leadingIcon={<Templates />}
            id="reports_templates"
            title={formatMessage({ id: 'reports_templates' })}
            titleWeight={contextMenuTitleWeightOptions['TEXT-600']}
            onClick={handleClickReportTemplates}
          />
        )}
      </ContextMenuComponent.List>
    </ContextMenuComponent.Root>
  )
}

OrganizationalMenu.propTypes = {
  onClickManageUsers: PropTypes.func,
  onClickReportTemplates: PropTypes.func
}

export default OrganizationalMenu
